<template>
  <section id="searchBrand" ref="searchBrand">
    <GarageBrand :brand_name="brand" :brand_id="carBrandId" :color_kv="color"></GarageBrand>
    <div hidden>VOLKSWAGEN Pre-owned Cars</div>
  </section>
</template>

<script>
import GarageBrand from '../components/GarageBrand'

let vm = null
export default {
  metaInfo: {
    title: 'Volkswagen Pre-owned Cars', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Volkswagen Pre-owned Cars'
    },
    {
      name: 'description',
      content: 'Volkswagen Pre-owned Cars – Buy premium condition pre-owned cars with warranty.'
    }]
  },
  name: "VOLKSWAGEN",
  data() {
    return {
      metaData: 'Volkswagen Pre-owned Cars',
      carBrandId: 22,
      brand: 'Volkswagen',
      color: '#1B406E',
      favicon: '/favicon_Volkswagen.ico'
    };
  },
  created() {
  },
  async mounted() {
    this.setFavicon()
  },
  beforeDestroy() {
    this.resetFavicon()
  },
  methods: {
    setFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = this.favicon
      }
    },
    resetFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = '/favicon.ico'
      }
    }
  },
  components: {
    GarageBrand
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Volkswagen.vue